import { createContext } from "react"
import { useParams } from "react-router-dom"
import useUploadDocumentsLogic from "./hooks/useUploadDocumentsLogic"
import { Card, Col, Container, Row, Table } from "react-bootstrap"
import Loader2 from "../../../../../components/Loader2"
import DocumentTable from "./components/DocumentTable"
import DocumentHeader from "./components/DocumentHeader"
import SmartModal from "../../../../../components/Modals/SmartModal"
import UploadDocumentForm from "./form/UploadDocumentForm"
import LoadingModal from "../../../../../components/LoadingModal"

export const UploadDocumentsContext = createContext(null)

export default function UploadDocuments(){

    const { id } = useParams()
    
    const context = useUploadDocumentsLogic(id)

    const {
        invoiceData,
        deleteModalLogic,
        
        isLoadingResources,
        isLoadingHttpRequest,
    } = context ?? {}



    if(!id) return <h1 className="text-danger">Invalid page redirect</h1>

    return (
        <UploadDocumentsContext.Provider value={context}>
                {isLoadingResources ? <Loader2/>
                : (
                    <Container fluid>
                        <Row>
                            <DocumentHeader />
                            <Col md={6} className="order-2 order-md-1">
                                <Card className="p-5 d-flex rounded shadow">
                                    <Card.Body>
                                        {invoiceData?.table?.length == 0 ? 
                                            <h3 className="m-0">No documents uploaded yet.</h3>
                                        : (
                                            <div style={{maxHeight: '600px', minHeight: '600px', overflowY: 'auto'}}>
                                                <DocumentTable />
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} className="align-content-top justify-content-center order-1 order-md-2">
                                <Card className="rounded shadow">
                                    <Card.Body>
                                        <UploadDocumentForm />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <LoadingModal showWhen={isLoadingHttpRequest}/>
                        <SmartModal {...deleteModalLogic}/>
                    </Container>
                )}
        </UploadDocumentsContext.Provider>
    )
}